import styled, { css } from 'styled-components';

import {
  Heading,
  breakpoints,
  ImagePlaceholder,
  theme,
} from '@notino/react-styleguide';

export const ModalHeader = styled(Heading.H3)`
  text-align: left;
  margin: 0 auto;
  ${theme.typography.titleLarge}
`;

export const DiamondIconWrapper = styled.div`
  display: flex;
  flex-basis: 20%;
  height: 100%;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  max-height: 90vh;

  @media (min-width: ${breakpoints.md}) {
    flex-direction: row-reverse;
    height: auto;
  }

  flex-direction: column-reverse;
  max-height: 80vh;
  overflow-y: auto;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  padding: 2rem 0;

  @media (min-width: ${breakpoints.md}) {
    width: 50%;
  }
`;

export const TextContentWrapper = styled.div`
  display: flex;
  padding: 1rem;

  @media (min-width: ${breakpoints.md}) {
    padding: 2rem;
  }

  padding: 0 1.25rem 1.5rem;
  flex-direction: column;
  gap: 1rem;

  @media (min-width: ${breakpoints.md}) {
    padding: 0 2rem 1.5rem;
  }
`;

export const InfoWrapper = styled.div`
  flex-basis: 75%;

  @media (min-width: ${breakpoints.md}) {
    flex-basis: 80%;
  }
`;

export const ImageWrapper = styled.div<{ hideOnMobile: boolean }>`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;

  ${({ hideOnMobile }) =>
    hideOnMobile &&
    css`
      display: none;
    `}

  @media (min-width: ${breakpoints.md}) {
    display: flex;
    align-items: center;
  }
`;

export const StyledImagePlaceholder = styled(ImagePlaceholder)`
  min-width: 100%;
  min-height: 100%;
`;
